/**
 * @classdesc Dutch Language Pack
 * @desc This class will used to translate tokens into the Dutch language.
 * @namespace Languages.Dutch
 */

/**
 * @constant dictionary
 * @type {object}
 * @memberof Languages.Dutch
 */
export const dictionary = {
    'years'   : 'Jaren',
    'months'  : 'Maanden',
    'days'    : 'Dagen',
    'hours'   : 'Uren',
    'minutes' : 'Minuten',
    'seconds' : 'Seconden'
};

/**
 * @constant aliases
 * @type {array}
 * @memberof Languages.Dutch
 */
export const aliases = ['nl', 'nl-be', 'dutch'];
